import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';
import Modal from '../Modal';
import ModalLoading from '../Modal/ModalLoading';

export default function ModalDownload({
  isLoading,
  excelLink,
  pdfLink,
  open,
  onClickExcel,
  onClickPdf,
  onClose,
}) {
  const [lastStateUpdate, setLastStateUpdate] = useState(0);

  useEffect(() => {
    setLastStateUpdate(new Date().getMilliseconds());
  }, [excelLink, pdfLink, isLoading]);

  if (isLoading) {
    return <ModalLoading onDismiss={onClose} visible={open} />;
  }

  return (
    <Modal
      className={styles.modal}
      lastUpdate={lastStateUpdate}
      onClose={onClose}
      open={open}
    >
      <div className={styles['modal-header']}>
        <h3>Unduh File</h3>
        <p>Pilih tipe dokumen yang ingin Anda unduh</p>
      </div>
      <div className={styles['modal-body']}>
        <button
          disabled={!(onClickExcel || excelLink)}
          onClick={onClickExcel ? onClickExcel : () => window.open(excelLink)}
        >
          <img alt="Excel" src="assets/ic-excel.svg" />
          <span>Excel</span>
        </button>
        <button
          disabled={!(onClickPdf || pdfLink)}
          onClick={onClickPdf ? onClickPdf : () => window.open(pdfLink)}
        >
          <img alt="pdf" src="assets/ic-pdf.svg" />
          <span>PDF</span>
        </button>
      </div>
    </Modal>
  );
}

ModalDownload.propTypes = {
  excelLink: PropTypes.string,
  isLoading: PropTypes.bool,
  onClickExcel: PropTypes.func,
  onClickPdf: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  pdfLink: PropTypes.string,
};
